'use client'

import { IconMapPin } from '@tabler/icons-react'

interface LocationSharedCardProps {
  latitude: number
  longitude: number
}

export function LocationSharedCard({ latitude, longitude }: LocationSharedCardProps) {
  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${longitude - 0.01},${latitude - 0.01},${longitude + 0.01},${latitude + 0.01}&layer=mapnik&marker=${latitude},${longitude}`

  return (
    <div className="my-2 overflow-hidden rounded-xl border border-border/50">
      <iframe
        src={mapUrl}
        className="h-48 w-full border-0"
        loading="lazy"
        title="Shared location"
      />
      <div className="flex items-center gap-2 px-3 py-2 text-xs text-muted-foreground">
        <IconMapPin size={14} />
        <span>{latitude.toFixed(5)}, {longitude.toFixed(5)}</span>
      </div>
    </div>
  )
}
